import React, { useContext, useEffect, useState, } from 'react';
import styled, { ThemeContext } from 'styled-components';
import * as icons from '@boxine/tonies-ui/icons';
import { useTranslation } from 'react-i18next';
import { media } from '../themes/theme';
import Icon from '../Icon';
import { FocusStyles } from '../../styles/FocusStyles';
import { StatusIcon } from './StatusIcon';
function getBorderColor(type, theme) {
    switch (type) {
        case 'error':
            return theme.BrandPrimary;
        case 'info':
            return theme.Success;
        case 'warning':
            return theme.BrandInfo;
        case 'success':
            return theme.Green;
    }
}
const Wrapper = styled.section `
  align-items: center;
  background-color: ${props => props.theme.White};
  border-radius: 0.375rem;
  border: 0.25rem solid ${props => getBorderColor(props.type, props.theme)};
  box-shadow: 1px 5px 7px 0 rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 8px;
  min-height: 1rem;
  padding: 0.5rem;

  ${media.tablet `
    border: none;
    border-left: 1rem solid ${props => getBorderColor(props.type, props.theme)};
    flex-direction: row;
    padding: 2rem;
  `};
`;
const InnerWrapper = styled.div `
  align-items: center;
  display: flex;
  flex-direction: column;

  ${media.tablet `
    flex-direction: row;
  `}
`;
const CloseButton = styled.button `
  background: none;
  border: none;
  height: 2rem; /* Limit height to the exact icon size */
  padding: 0;
  cursor: pointer;

  ${FocusStyles}
`;
export const FlashMessage = ({ children = null, className, 'data-testid': dataTestId = 'flash-message', isPersistent = false, onWasClosed = undefined, type, }) => {
    const theme = useContext(ThemeContext);
    const { t } = useTranslation('FlashMessage');
    const [isVisible, setIsVisible] = useState(true);
    useEffect(() => {
        if (typeof onWasClosed !== 'undefined' && !isVisible) {
            onWasClosed();
        }
    }, [isVisible, onWasClosed]);
    return isVisible ? (React.createElement(Wrapper, { className: className, "data-testid": dataTestId, type: type },
        React.createElement(InnerWrapper, null,
            React.createElement(StatusIcon, { type: type }),
            children),
        !isPersistent && (React.createElement(CloseButton, { "aria-label": t('Close'), "data-testid": "flash-message-close-button", onClick: () => setIsVisible(false), type: "button" },
            React.createElement(Icon, { type: icons.closeX, fill: theme.colors.normalgrey, width: 32, height: 32, title: t('Close') }))))) : null;
};
